import { getActiveExperiments } from '@atc/optimizely-toolkit';

import experimentDuck from '@/ducks/experimentDuck.js';

/**
 * Middleware to collect server-side Optimizely decisions and prepare them for client propagation
*/
export default function withOptimizelyExperiments() {
    return async (ctx) => {
        if (typeof window === 'undefined') {
            ctx.store.dispatch(experimentDuck.creators.setExperiments(getActiveExperiments()));
        }
    };
}
